import { Provider, WorksheetResult, fetchRequest } from '.'

function allProvidersPayload(locationCode: string, departmentCode?: string) {
  return {
    service: 'providersmanager',
    action: 'getprovidersapi',
    workflow: 'providerAdminStd',
    data: {
      locationCodes: [locationCode],
      filter: {
        active: true,
        lastName: null,
        providerId: null,
        userId: null,
        email: null,
        login: null,
        degrees: null,
        departments: departmentCode ? [departmentCode] : null,
        activeStatus: null,
        // TODO : move returning undefined to BE
        // ignoreProvider: null,
        profee: null,
      },
    },
  }
}

export const locationProvidersRequest = fetchRequest<[string,string], WorksheetResult<Provider[]>>({
  method: 'post',
  body: ([locationCode, departmentCode]) => {
    return allProvidersPayload(locationCode, departmentCode)
  },
})

export async function locationProviders(locationCode: string, departmentCode: string): Promise<Provider[]> {
  const resp = await locationProvidersRequest([locationCode, departmentCode])
  if (!resp?.success) {
    return []
  }
  if (!resp?.result) {
    return []
  }
  let list = resp.result

  // Ivan Porokh
  // ignoreProvider = false should return false/undefined
  console.info('locationProviders pre filter', list.length)
  list = list.filter((p) => p.ignoreProvider === undefined || p.ignoreProvider === false)
  console.info('locationProviders post filter', list.length)
  return list
}

export function providerSearch(locationCode: string, departmentCode?: string): (search: string) => Promise<Provider[]> {
  return async (search: string) => {
    if (search?.length < 3) {
      return []
    }

    const body = allProvidersPayload(locationCode, departmentCode)
    body.data.filter.lastName = search
    const fetch = fetchRequest<undefined, WorksheetResult<Provider[]>>({
      method: 'post',
      body: () => body,
    })

    const resp = await fetch()
    if (!resp?.success) {
      return []
    }
    if (!resp?.result) {
      return []
    }
    return resp.result
  }
}
